<template>
    <div>
        <h1 style="font-size: 24px; color: black;">变现收入汇总表</h1>
        <el-card   shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                    <span> 应用名称： </span>
                    <el-select  v-model="queryData.appId" >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option
                                v-for="item in appList"
                                :label="item.appName"
                                :value="item.appId"
                                :key="item.appId">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <span> 投放媒体： </span>
                    <el-select  v-model="queryData.mediaId" >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option v-for="(value, key) in mediaObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="7">
                    <span > 日期：</span>
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="monthrange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :span="2">
                    <el-button  type="primary" @click="queryList">查询</el-button>
                    <el-button  type="primary" @click="downloadData">导出</el-button>
                </el-col>
            </el-row>
        </el-card>
        <h1></h1>
        <br>
        <el-row :gutter="16">
            <el-col :span="5">
                <div class="sum-style">
                    <el-card shadow="always" :body-style="sumStyle">
                        <p>变现收入总计</p>
                        <p>￥：{{sumData.totalIncome | thousandthOnly}}</p>
                    </el-card>
                </div>
            </el-col>
            <el-col :span="5">
                <div class="sum-style">
                    <el-card shadow="always" :body-style="sumStyle">
                        <p>开票费用总计</p>
                        <p>￥：{{sumData.totalInvoiceMoney | thousandthOnly}}</p>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <br>
        <el-table border :data="topicList"  >
            <el-table-column  label="月份时间"  prop="dt" >
                <template slot-scope="scope">
                    {{ scope.row.dt | dateFormat}}
                </template>
            </el-table-column>
            <el-table-column  label="应用"  prop="appId" >
                <template slot-scope="scope">
                    {{ scope.row.appId | commonFilter(appObj)}}
                </template>
            </el-table-column>
            <el-table-column  label="业务组"  prop="deptId" >
                <template slot-scope="scope">
                    {{ scope.row.deptId | commonFilter(deptObj)}}
                </template>
            </el-table-column>
            <el-table-column  label="投放媒体"  prop="mediaId" >
                <template slot-scope="scope">
                    {{ scope.row.mediaId | commonFilter(mediaObj)}}
                </template>
            </el-table-column>
            <el-table-column  label="付款公司"  prop="companyId" >
                <template slot-scope="scope">
                    {{ scope.row.companyId | commonFilter(companyObj)}}
                </template>
            </el-table-column>
            <el-table-column  label="变现收入"  prop="income" ></el-table-column>
            <el-table-column  label="关联OA开票ID"  prop="invoiceId" ></el-table-column>
            <el-table-column  label="开票金额"  prop="invoiceMoney" ></el-table-column>
            <el-table-column  label="未回款金额"  prop="invoiceMoney" ></el-table-column>
            <el-table-column  label="是否已回款"  prop="backMoney" >
                <template slot-scope="scope">
                    {{ scope.row.backMoney | yesOrNo }}
                </template>
            </el-table-column>
            <el-table-column  label="费用凭证" width="120px" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.image !== null && scope.row.image !== ''">
                        <el-popover trigger="hover" placement="left">
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="925px" height="425px" alt="banner图片">
                            <img :src="VUE_APP_CDN_URL+scope.row.image" slot="reference" width="50px" height="50px" alt="图片">
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column  label="操作" align="center">
                <template slot-scope="scope">
                    <el-button  plain size="mini" type="primary" @click="showDetails('上传凭证',scope.row)">上传凭证</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="pageSizes"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </el-row>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
            <el-form :model="editForm" label-width="150px">
                <el-form-item label="费用凭证:" label-width="150px">
                    <el-upload
                            :headers="headers"
                            class="avatar-uploader"
                            :action="uploadURL"
                            :show-file-list="false"
                            :on-success="handleImageSuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file)}"
                            @click="uploadImage">
                        <img v-if="editForm.image" :src="VUE_APP_CDN_URL+editForm.image" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm">确 定</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        FcMonthDataList,
        saveFcMonthData,
        upload,
    } from "@/http/financialApi";
    import {states, settlementTypes} from '@/constants/common/basic-data'
    import settingMix from '@/utils/mix/common-setting'
    import pageMix from '@/utils/mix/page'
    import DateUtil from '@/utils/DateUtil'
    import {commonFilter1, dateFormat} from "../../filters";
    import Export from '@/utils/ExportData'
    export default {
        name: "FcMonthData",
        mixins: [settingMix,pageMix],
        data(){
            return{
                VUE_APP_FINANCIAL_URL:'',
                VUE_APP_CDN_URL:'',
                headers:{},
                editForm: {},
                dialogVisible: false,
                dialogTitle :'',
                uploadURL: process.env.VUE_APP_FINANCIAL_URL + "sharedExpenses/upload",
                queryData: {
                    appId: -1,
                    mediaId: -1,
                    timeDate: ['', ''],
                },
                sumData:{
                    totalIncome: 0.0,
                    totalInvoiceMoney: 0.0
                },
                topicList:[],
                needGetApp: true,
                appList:[],
                needDept: true,
                deptObj: {},
                needGetMedia: true,
                mediaType: 1,
                mediaObj: {},
                needGetCompany: true,
                companyObj: {},
                states: states,
                settlementTypes: settlementTypes,
                sumStyle: {
                    backgroundColor: 'rgba(0, 128, 110, 0.94)',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    padding: 0,
                    height: '70px',
                    display: 'flex',
                    // flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                excelHeaders:[
                    { dt: '月份时间' },
                    { appId: '应用' },
                    { deptId: '业务组' },
                    { mediaId: '投放媒体' },
                    { companyId: '付款公司' },
                    { income: '变现收入' },
                    { invoiceId: '关联OA开票ID(未使用)'},
                    { invoiceMoney: '开票金额(未使用)' },
                    { invoiceMoney: '未回款金额(未使用)' },
                    { backMoney: '是否已回款(未使用)' }
                ]
            }
        },
        methods :{
            queryList(){
                let queryTrueData = {appId: this.queryData.appId, mediaId: this.queryData.mediaId}
                queryTrueData.startDt = this.queryData.timeDate[0]==='' ? null:this.queryData.timeDate[0];
                queryTrueData.endDt = this.queryData.timeDate[1]==='' ? null:this.queryData.timeDate[1];
                queryTrueData = this.mergePage(queryTrueData)
                FcMonthDataList(queryTrueData).then(resp=> {
                    if (resp.data.status===0){
                        this.topicList=resp.data.info.content
                        // eslint-disable-next-line no-undef,no-prototype-builtins
                        if(resp.data.info.hasOwnProperty("totalIncome")){
                            this.sumData = {totalIncome: resp.data.info.totalIncome, totalInvoiceMoney: resp.data.info.totalInvoiceMoney}
                        }
                        this.setTotal(resp.data.info)
                    }
                })
            },
            initDateRange(){
                this.queryData.timeDate = DateUtil.getIntervalMonthWithNoFormat(1)
            },
            downloadData(){
                let queryTrueData = {appId: this.queryData.appId, mediaId: this.queryData.mediaId};
                queryTrueData.startDt = this.queryData.timeDate[0]==='' ? null:this.queryData.timeDate[0];
                queryTrueData.endDt = this.queryData.timeDate[1]==='' ? null:this.queryData.timeDate[1];
                queryTrueData = this.mergePage(queryTrueData);
                this.loading = true;
                FcMonthDataList(Object.assign(queryTrueData,{size: 100000, page: 1})).then(resp=>{
                    if (resp.data.status===0){
                        this.loading = false;
                        resp.data.info.content.forEach(item => {
                            item.dt = dateFormat(item.dt);
                            item.mediaId = commonFilter1(item.mediaId,this.mediaObj);
                            item.appId = commonFilter1(item.appId,this.appObj);
                            item.deptId = commonFilter1(item.deptId,this.deptObj);
                            item.companyId = commonFilter1(item.companyId,this.companyObj);
                            item.backMoney = item.backMoney===1?'是':'否';
                        });
                        Export.downloadExl(resp.data.info.content, '变现收入汇总表', this.excelHeaders)
                    }
                });
            },
            showDetails(title, row) {
                this.editForm = {
                    "id" : 0,
                    "dt":'',
                    "deptId" :1,
                    "appId" : 1,
                    "mediaId" : 1,
                    "companyId" : 1,
                    "income": 0,
                    "invoiceId": 1,
                    "invoiceMoney": 0,
                    "backMoney": 0,
                    "image": '',

                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if(row){
                    this.editForm = {
                        "id" : row.id,
                        "dt":row.dt,
                        "deptId" :row.deptId,
                        "appId" : row.appId,
                        "mediaId" : row.mediaId,
                        "companyId" : row.companyId,
                        "income": row.income,
                        "invoiceId": row.invoiceId,
                        "invoiceMoney": row.invoiceMoney,
                        "backMoney": row.backMoney,
                        "image": row.image
                    };
                }
            },
            handleImageSuccess(response){
                this.editForm.image=response.info;
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 5;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过5MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            uploadImage(){
                let func = upload;
                func().then().catch(function () {
                })
            },
            confirmForm(){
                saveFcMonthData(this.editForm).then(resp => {
                    if (resp.data.status === 0 ){
                        this.queryList();
                        this.dialogVisible = false;
                    }
                });
            },
        },
        created() {
            this.headers ={Authorization : this.$store.state.user.token};
            this.initDateRange()
            this.queryList();
        },
        mounted() {
            this.VUE_APP_FINANCIAL_URL=process.env.VUE_APP_FINANCIAL_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>
    .sum-style{
        height: 70px;
        width: 300px;
    }
</style>
